import { KartverketFlyFotoLayer } from "./KartverketFlyFotoLayer";
export default KartverketFlyFotoLayer;
